/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCONSULTANTSIGNINGROLE } from './IAPCONSULTANTSIGNINGROLE';
import {
    IAPCONSULTANTSIGNINGROLEFromJSON,
    IAPCONSULTANTSIGNINGROLEFromJSONTyped,
    IAPCONSULTANTSIGNINGROLEToJSON,
} from './IAPCONSULTANTSIGNINGROLE';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';

/**
 * 
 * @export
 * @interface ConsultantViewModel
 */
export interface ConsultantViewModel {
    /**
     * 
     * @type {number}
     * @memberof ConsultantViewModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ConsultantViewModel
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantViewModel
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantViewModel
     */
    contactNumber: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof ConsultantViewModel
     */
    countryCodeId?: IAPCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof ConsultantViewModel
     */
    countryDialingCode?: string;
    /**
     * 
     * @type {IAPCONSULTANTSIGNINGROLE}
     * @memberof ConsultantViewModel
     */
    role: IAPCONSULTANTSIGNINGROLE;
    /**
     * 
     * @type {boolean}
     * @memberof ConsultantViewModel
     */
    isSelected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConsultantViewModel
     */
    isExternal: boolean;
}

/**
 * Check if a given object implements the ConsultantViewModel interface.
 */
export function instanceOfConsultantViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fullName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "contactNumber" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "isSelected" in value;
    isInstance = isInstance && "isExternal" in value;

    return isInstance;
}

export function ConsultantViewModelFromJSON(json: any): ConsultantViewModel {
    return ConsultantViewModelFromJSONTyped(json, false);
}

export function ConsultantViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsultantViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'fullName': json['FullName'],
        'email': json['Email'],
        'contactNumber': json['ContactNumber'],
        'countryCodeId': !exists(json, 'CountryCodeId') ? undefined : IAPCOUNTRYFromJSON(json['CountryCodeId']),
        'countryDialingCode': !exists(json, 'CountryDialingCode') ? undefined : json['CountryDialingCode'],
        'role': IAPCONSULTANTSIGNINGROLEFromJSON(json['Role']),
        'isSelected': json['IsSelected'],
        'isExternal': json['IsExternal'],
    };
}

export function ConsultantViewModelToJSON(value?: ConsultantViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'FullName': value.fullName,
        'Email': value.email,
        'ContactNumber': value.contactNumber,
        'CountryCodeId': IAPCOUNTRYToJSON(value.countryCodeId),
        'CountryDialingCode': value.countryDialingCode,
        'Role': IAPCONSULTANTSIGNINGROLEToJSON(value.role),
        'IsSelected': value.isSelected,
        'IsExternal': value.isExternal,
    };
}

